import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export function updateSettingState(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_SETTING_STATE,
            payload,
            path
        });
    };
}

export function deleteSettingState(path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.DELETE_SETTING_STATE,
            path
        });
    };
}

export function getAllTeamMembers() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.TEAM_MEMBERS_LOADING,
        });
        API.getAllTeamMembers({}, (error, response) => {
            log('get all team members response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.TEAM_MEMBERS_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.TEAM_MEMBERS_LOAD_ERROR,
                });
            }
        });
    };
}

export function addNewMembers(data, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.NEW_MEMBERS_ADDING,
        });
        API.addNewMembers(data, (error, response) => {
            log('add new members response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.NEW_MEMBERS_ADDED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response.message ? response.message : 'new member successfully added.');
            } else {
                dispatch({
                    type: actionTypes.NEW_MEMBERS_ADDITION_ERROR,
                });
            }
        });
    };
}

export function deleteTeamMember(data) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "deleting"
        });
        API.deleteTeamMember(data, (error, response) => {
            log('delete member response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS,
                    payload: response.data,
                });
                showMessage('success', `${data.email} has been successfully deleted.`);
            }
        });
    };
}

export function changeMemberActivation(data) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: data.isActive ? "Activating" : "Deactivating"
        });
        API.changeMemberActivation(data, (error, response) => {
            log('toggle member activation response:', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS,
                    payload: response.data,
                });
                showMessage('success', `${data.email} has been successfully ${data.isActive ? "activated" : "deactivated"}.`);
            }
        });
    };
}

export function getUserPermissions(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.USER_PERMISSIONS_LOADING,
        });
        API.getUserPermissions(data, (error, response) => {
            log('user permissions response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: actionTypes.USER_PERMISSIONS_LOADED,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.USER_PERMISSIONS_LOAD_ERROR,
                });
            }
        });
    };
}

export function updateUserPermissions(data, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.USER_PERMISSIONS_UPDATING,
        });
        API.updateUserPermissions(data, (error, response) => {
            log('update user permissions response:', response);
            dispatch({
                type: actionTypes.USER_PERMISSIONS_UPDATION_COMPLETE,
            });
            if (!error && response && response.data) {
                showMessage('success', 'permissions successfully updated');
                if (callback) callback();
            }
        });
    };
}





// WEBPACK FOOTER //
// ./src/data/redux/team_member_setting_details/actions.js